import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { maskValue } from '../../../services/masks';

const LocationsMobileColumn = ( { row } ) => {
	return (
		<div style={{
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		}}>
			<span><strong>{ row.name ? `${ row.name }` : `${ row.lastName }, ${ row.firstName }` }</strong></span>
			<br/>
			<address style={{
				whiteSpace: 'nowrap',
				overflow: 'hidden',
				textOverflow: 'ellipsis'
			}}>
				<span>
					{ row.address }
              &nbsp;
					{ row.address2
						? <span className="no-break">{ row.address2 }</span>
						: null
					}
				</span>
				<br/>
				<span>{ `${ row.city }, ${ row.state } ${ row.zip }` }</span>
			</address>
			<span>{ maskValue( 'phone', row.phone.number ) }</span>
		</div>
	);
};

LocationsMobileColumn.propTypes = { row: PropTypes.object.isRequired };

export default memo( LocationsMobileColumn );
